import { useContext } from 'react'

import type { BulkSelectionContextValue } from './BulkSelectionContext'
import { BulkSelectionContext } from './BulkSelectionContext'

export const useBulkSelection = (): BulkSelectionContextValue => {
  const ctx = useContext(BulkSelectionContext)
  if (!ctx)
    throw new Error(
      'useBulkSelection must be used within BulkSelectionProvider'
    )
  return ctx
}
